import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';

const namespace = 'Chatbot';

const Types = {
    actions: {},
    mutations: {
        OPEN_CHATBOT: 'openChatbot',
        CLOSE_CHATBOT: 'closeChatbot',
        TOGGLE_CHATBOT: 'toggleChatbot',
        NEW_MESSAGE: 'newMessage',
        DISPLAY_CHATBOT: 'displayChatbot',
    },
};

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
